module.exports = __webpack_public_path__ + "media/images/ic-pin-green-fullfiled-225d6ed646715e535c710f627e517895.svg";